let STYLE = {};

STYLE.FONT = {
  SIZE: 18,
  FAMILY: "Asap Condensed",
};

export default STYLE;
